import { useUI } from "../../stores/ui";

const OPTIONS = [
  { id: "doc" as const, label: "Documento" },
  { id: "col" as const, label: "Colección" },
  { id: "all" as const, label: "Todo" },
];

export function ScopeStrip() {
  const scope = useUI((s) => s.scope);
  const setScope = useUI((s) => s.setScope);
  return (
    <div className="scope-strip" data-testid="scope-strip" aria-label="Ámbito de búsqueda y chat">
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          type="button"
          className={`scope-strip-opt ${scope === o.id ? "active" : ""}`}
          data-testid={`scope-opt-${o.id}`}
          data-active={scope === o.id ? "true" : "false"}
          onClick={() => setScope(o.id)}
        >
          <span className="scope-dot" />
          {o.label}
        </button>
      ))}
    </div>
  );
}
